import React from 'react';
import styles from './Applicators.module.scss'
import ApplicatorsTable from "../../../components/ApplicatorsTable/ApplicatorsTable";


const AdminApplicators = () => {
    return (
        <div className={ styles.container }>
            <div className={ styles[ 'box' ] }>
                <ApplicatorsTable userType={ 5 } />
            </div>
        </div>
    )
}

export default AdminApplicators;
